module.exports = __webpack_public_path__ + "img/materials_cn.a0551b2.jpg";